import { SET_USER, LOGOUT } from './actionTypes';

export const setUserAction = (user) => ({
  type: SET_USER,
  user,
});
export const logoutAction = () => ({
  type: LOGOUT,
});
